import {Link} from '@shopify/hydrogen';
import clsx from 'clsx';

import {useCartUI} from '../cart/CartUIProvider.client';

const CartNotification = () => {
  const {cartNotification} = useCartUI();

  return (
    <div
      className={clsx([
        'transition-standard blockH9 transition-standard fixed top-0 z-[999] flex w-full items-center justify-center gap-x-4 bg-orange px-gutter py-2 text-center font-bold text-white',
        cartNotification
          ? 'translate-y-0'
          : 'pointer-events-none -translate-y-full opacity-0',
      ])}
    >
      <span>Item added to cart!</span>
      <Link
        to="/cart"
        rel="nofollow"
        className="underline"
        data-testid="cart-notification-view-cart-button"
      >
        View Cart
      </Link>
    </div>
  );
};

export default CartNotification;
